var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('keep-alive',{attrs:{"include":['trainingCenter']}},[(_vm.$route.meta.keepAlive)?_c('router-view',{key:_vm.cacheKey,staticClass:"router-view"}):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view',{staticClass:"router-view"}):_vm._e(),(_vm.isSprite)?_c('ThreeSprite'):_vm._e(),_c('CheckUpdate')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }